import $ from 'jquery'

$('.header-menu-link--has-sub').on('mouseenter', function () {
  const name = $(this).find('span').text()

  if (name == 'Shop') {
    $('.advanced-header-dropdown[data-name="Shop"]').addClass('advanced-header-dropdown--active')
  } else if (name == 'Bundles') {
    $('.advanced-header-dropdown[data-name="Bundles"]').addClass('advanced-header-dropdown--active')
  }
})

$('.header-menu-link--has-sub').on('mouseleave', function () {
  $('.advanced-header-dropdown').removeClass('advanced-header-dropdown--active')
})
